/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { getAuthorizationHeader } from 'utils/Helpers'
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { RequestContentType } from 'utils/Helpers'
import { serializeObject } from 'utils/Helpers'
import UserStatusEnum from 'constants/UserStatusEnum'

const UserAPI = Marty.createStateSource({
  id: 'UserAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  createUserWithEmail(email, password = null) {
    const body = { email }
    if (password != null) { body.password = password }

    return this.post({
      contentType: RequestContentType.JSON,
      url: `/users?clientId=${ ResourcesConstants.CLIENT_ID }`,
      body: JSON.stringify(body)
    })
  },

  sendWelcomeEmail(isMobile) {
    if (isMobile == null) { isMobile = true }
    return this.post({
      url: `/users/welcome?mobile=${ isMobile }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON
    })
  },

  fetchUser(userId) {
    return this.get({
      url: `/users/${ userId }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchUsersForOrgId(orgId) {
    return this.get({
      url: `/organizations/${ orgId }/users?status=INVITED&status=ENABLED`,
      headers: getAuthorizationHeader()
    })
  },

  fetchCurrentLoggedInUser() {
    return this.get({
      url: '/users/me',
      headers: getAuthorizationHeader()
    })
  },

  getUserExistsByEmail(email) {
    const queryParams = serializeObject({ email })
    return fetch(`${ this.baseUrl }/users/?${ queryParams }`, {
      method: 'HEAD'
    })
  },

  getUserExistsByEmailAndOrgHandle(email, orgHandle) {
    const queryParams = serializeObject({ email, orgHandle })
    return fetch(`${ this.baseUrl }/users/?${ queryParams }`, {
      method: 'HEAD'
    })
  },

  updateUser(userId, params) {
    return this.patch({
      url: `/users/${ userId }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(params)
    })
  },

  changePassword(userId, password) {
    return this.post({
      url: `/users/${ userId }/password?clientId=${ ResourcesConstants.CLIENT_ID }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify({
        password
      })
    })
  },

  uploadUserAvatar(userId, file) {
    const data = new FormData()
    data.append('file', file)
    return this.post({
      url: `/users/${ userId }/avatar`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.FORM_DATA,
      body: data
    })
  },

  archiveUser(userId) {
    return this.patch({
      url: `/users/${ userId }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify({ status: UserStatusEnum.ARCHIVED.key })
    })
  },

  archiveUsers({ orgId, userIds }) {
    return this.delete({
      url: `organizations/${orgId}/users`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(userIds)
    })
  }
})

export default UserAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/UserAPI.js